let glightbox;

import GLightbox from 'glightbox';

const lightbox = GLightbox({});

export default glightbox;
